let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jTSmJ")).then(() => parcelRequire('1neYb'));